export const TAB_TYPES = {
  CAMPAIGN: "campaign",
  ASSET: "asset",
};

export const EMAIL_TAB_TYPES = {
  TEST: "test",
  SENT: "sent",
  SCHEDULED: "scheduled",
  ALL: "all",
};

export const EMAIL_TABS_MAP = {
  [EMAIL_TAB_TYPES.TEST]: { test_emails: true },
  [EMAIL_TAB_TYPES.SENT]: { test_emails: false },
  [EMAIL_TAB_TYPES.SCHEDULED]: {},
  [EMAIL_TAB_TYPES.ALL]: {},
};
